import React, { useState, useEffect } from 'react';
import './PanelItem.css';
import { Grid } from '@mui/material';
import ContactForm from './ContactForm';
import CustomIconButton from '../../inputFields/CustomIconButton';
import AddressForm from '../addressForm';
import Tooltip from '@mui/material/Tooltip';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import GpsFixedIcon from '@mui/icons-material/GpsFixed';
import CustomDialog from '../../dialog/Dialog';
import httpRequest from '../../../../HttpService';
 
const PanelItem = props => {
    const [openDialog, setOpenDialog] = useState(false);
    const [showEditAddressForm, setShowEditAddressForm] = useState(false);
    // This local state is crucial. It holds the most current version of the address for this specific item.
    const [addressData, setAddressData] = useState(props.data);
 
    // This ensures that if the parent list provides new data (e.g., after a search), this item updates itself.
    useEffect(() => {
        setAddressData(props.data);
    }, [props.data]);
 
    const toggleDialog = () => {
        setOpenDialog(!openDialog);
    };
 
    const deleteLocation = () => {
        setOpenDialog(!openDialog);
        httpRequest.removeAddress(props.accountNumber, addressData).then(function (response) {
            props.removedAddressIndex(props.index);
            console.log("removeAddress" + JSON.stringify(response.data));
        });
    };
 
    const handleClick = (event) => {
        if(props.selected)
            setShowEditAddressForm(!showEditAddressForm);
    };
 
    /**
     * This is the callback function that receives the updated address object
     * from ContactForm OR AddressForm after a successful API call has completed.
     * It updates this item's local state and informs the parent AddressPanel.
     */
    const handleContactUpdate = (updatedAddress) => {
        setAddressData(updatedAddress);
        // Also inform the main AddressPanel component that an item in its list has changed.
        if (props.onAddressUpdate) {
            props.onAddressUpdate(props.index, updatedAddress);
        }
    };
 
    let dateFormatted = "";
    if (addressData.LastDate) {
        const date = new Date(addressData.LastDate.split("T")[0]);
        const dateString = date.toDateString();
        dateFormatted = dateString.split(" ")[1] + " " + dateString.split(" ")[2] + ", " + dateString.split(" ")[3];
    }
 
    const isHighlighted = props.highlighted;
 
    return (
        <Grid
            container
            className={`panel-item-box${props.selected ? "" : "-unselected"}${isHighlighted ? " keyboard-highlighted" : ""}`}
            spacing={1}
            key='panel'
        >
            <Grid item lg={9} sm={8} xs={12}>
                <div className="panel-item-title">
                    <h3>{addressData.companyName}</h3>
                </div>
                <div className="panel-item-info">
                    {(addressData.suite !== '') ?
                        (<p>Suite {addressData.suite},  {addressData.address}, {addressData.quad}</p>)
                        : (<p>{addressData.address}, {addressData.quad}</p>)
                    }
                    <p>{addressData.city}, {addressData.prov}, {addressData.country}, {addressData.postal} &nbsp;
                        <Tooltip title={addressData.addressID} placement="top" arrow>
                            <LocationOnIcon style={{fontSize: "14px"}}/>
                        </Tooltip>
                    </p>
                    <p>
                        <strong>Last delivery completed:&nbsp;</strong>
                        {dateFormatted} &nbsp;
                        <Tooltip title={`${addressData.lat}, ${addressData.long}`} placement="top" arrow>
                            <GpsFixedIcon style={{fontSize: "14px", display: "inline"}}/>
                        </Tooltip>
                    </p>
                </div>
            </Grid>
            <Grid item lg={3} sm={4}>
            {props.selected && <div style={{float: 'right'}}>
                    <CustomIconButton
                        icon="VisibilityOffIcon"
                        tooltip="Remove from this list"
                        onClick={toggleDialog}
                        variant="outlined"
                        color="primary"
                        selected={props.selected}
                        style={{marginRight: '2px'}}
                    />
                    <CustomIconButton
                        icon="CreateIcon"
                        tooltip="Edit Address"
                        onClick={handleClick}
                        variant="outlined"
                        color="primary"
                        selected={props.selected}
                    />
                    <CustomDialog
                        open={openDialog}
                        onClose={toggleDialog}
                        dialogTitle="Warning"
                        dialogMessage="Address will be removed from this list but will still be accessable when searching"
                        dialogAction={deleteLocation}
                    />
                </div>}
            </Grid>
            {props.selected && !showEditAddressForm &&
                <ContactForm
                    data={addressData}
                    accountNumber={props.accountNumber}
                    onContactUpdate={handleContactUpdate} // Pass the update handler down
                    type={props.type}
                />
            }
            {(showEditAddressForm && props.selected) && (
                <div className="fixedElement">
                    <AddressForm
                        title="Edit Address"
                        cancelButtonLabel="Cancel"
                        saveButtonLabel="Save Address"
                        variant="edit"
                        cancelButtonOnClick={() => {handleClick();}}
                        updatedAddress={handleContactUpdate} // The edit form can reuse the same update handler
                        data={addressData}
                        accountNumber={props.accountNumber}
                    />
                </div>
            )}
        </Grid>
    );
};
 
export default PanelItem;